import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  // formGroupValue: any
  files: any[]
  // checkOutRedirectUrl: string
  service: any
  paymentObj: any
}

@Component({
  selector: 'app-efinance-form',
  standalone: false,
  templateUrl: './efinance-form.component.html'
})
export class EfinanceFormComponent implements OnInit {
  PaymentObj: any
  paymentProvider = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<EfinanceFormComponent>,
  ) { }

  ngOnInit(): void {
    this.PaymentObj = this.data.paymentObj;
  }
}
